import { render, staticRenderFns } from "./HbProductTab.vue?vue&type=template&id=6caee4f2&"
import script from "./HbProductTab.vue?vue&type=script&lang=js&"
export * from "./HbProductTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports